import { MultiSelectProvider } from './multi-select.provider';
import { MultiSelect, MultiSelectOption } from './multi-select.view';
import { MultiSelectViewModel, WithId } from './multi-select.view-model';
import React from 'react';
const MultiSelectRoot = <TValue extends WithId = WithId>({
  vm,
  children,
  placeholder
}: {
  vm: MultiSelectViewModel<TValue>;
  children: React.ReactNode[];
  placeholder?: string 
}) => {
  const [viewModel] = React.useState(() => vm);
  return (
    <MultiSelectProvider vm={viewModel}>
      <MultiSelect placeholder={placeholder}>{children}</MultiSelect>
    </MultiSelectProvider>
  );
};

export { MultiSelectRoot as Root, MultiSelectOption as Option };
